export default __webpack_public_path__ + "static/media/nr2.8fd2b582.svg";